
export default () => ({
	async getGroups(params={}) {
		return _ps.getAllGroups();
	},
	async getGroup(groupKey, signerId, params={}) {
		// make sure it's loaded
		return new Promise((resolve) => {
			const group = _ps.getByKey(groupKey);
			if( group ) {
				resolve(group);
			} else {
				_ps.on('initialized', (a, b) => {
					_ps.site.set("signer_id", signerId);
					resolve(_ps.getByKey(groupKey));
				});
				_ps('load', groupKey, params);
			}
		});
	},
});
